import { createAction } from 'redux-actions';
export var setFirstTimeFlags = createAction('@@firstTimeFlags/SET_FLAGS');
export var dropFirstTimeFlag = createAction('@@firstTimeFlags/DROP_FLAG');
//# sourceMappingURL=actions.js.map